<template>
  <div class="section-card-slider list-product-slide" :class="[classModifier]">
    <div v-if="isLoadingFinish">
      <div v-if="$SO.size(products)">
        <div v-if="isDesktop" class="hidden-xs hidden-sm">
          <carousel
            :per-page-custom="[
              [991, 1],
              [992, perPageCustomProps || 6],
            ]"
            :navigation-enabled="true"
            :per-page="1"
            navigation-next-label
            navigation-prev-label
            :pagination-enabled="false"
            :navigation-click-target-size="0"
            @pageChange="pageChanged"
          >
            <slide
              v-for="(product, key) in products"
              :key="`desktop${key}`"
              @click.native="saveSearchHistoryClicks(product.id, 'product', product.name)"
            >
              <GProduct
                :key="key"
                :inline-reviewers="true"
                :button-review="true"
                :product="product"
                :object_type="object_type"
              />
            </slide>
          </carousel>
        </div>

        <div v-else class="hidden-md hidden-lg">
          <ul class="list-scrollable">
            <li
              v-for="(product, key) in products"
              :key="`mobile${key}`"
              @click="saveSearchHistoryClicks(product.id, 'product', product.name)"
            >
              <GProduct
                :key="key"
                :inline-reviewers="true"
                :button-review="true"
                :product="product"
                :object_type="object_type"
              />
            </li>
          </ul>
        </div>
      </div>
      <div v-else>
        <p class="text-helped">No Data Found.</p>
      </div>
    </div>
    <div v-else>
      <ListProductSlideLoader :per-page-custom-props="isDesktop ? perPageCustomProps : 2" />
    </div>
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
export default {
  name: 'ListProductSlide',
  components: {
    ListProductSlideLoader: () => import('@/components/global/loader/list-product-slide-loader'),
  },
  props: {
    classModifier: {
      type: String,
      required: false,
      default: '',
    },
    products: {
      type: Array,
      required: true,
    },
    isLoadingFinish: {
      type: Boolean,
      required: false,
    },
    perPageCustomProps: {
      type: Number,
      required: false,
      default: 6,
    },
    // eslint-disable-next-line vue/prop-name-casing
    object_type: {
      type: String,
      required: false,
      default: '',
    },
    section: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    isLogin() {
      return this.$store.state.auth.loggedin;
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  methods: {
    saveSearchHistoryClicks(entity_id, entity_type, name) {
      if (!this.isLogin) {
        return;
      }
      const params = {
        entity_id: entity_id, // id product
        keyword: name,
        entity_type: entity_type,
      };
      return axios.post(`${Config.MS_SOCO_PUBLIC_API_URL}/search-history-clicks`, params);
    },
    pageChanged(index) {
      if (this.section === 'product_match') {
        this.$emit('get-products', index);
      } else if (this.section === 'trending_products') {
        this.$emit('get-products-trending', index);
      } else if (this.section === 'have_you_tried_this') {
        this.$emit('get-products-try', index);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.product__brand {
  margin-bottom: 0;
}
</style>
